<template>
  <div>
    <Layout :pagetitle="$t('SysActivityLog')">
      <Table
        :title="$t('SysActivityLog')"
        :items="sys_activity_logTable"
        :columns="columns"
        :totalItems="totalItems"
        :searchable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onChangePage="changePage"
        :customColumn="true"
        :customColumnLabel="$t('Details')"
        @customColumnClick="showDetails"
      />
      <b-modal v-model="detailsModal" :title="$t('Details')" size="md" centered hide-footer id="log-modal-details">
        <div class="mr-2 ml-2 bg-dark text-white rounded p-4">
          <span>
            <span v-text="detailsPreview" />
            <i @click="copyDetails" class="copy-btn mdi mdi-file" :title="$t('Copy')"></i>
          </span>
        </div>
      </b-modal>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import authService from '@/services/auth.services';

export default {
  components: { Layout, Table },
  data() {
    return {
      detailsModal: false,
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'company_name',
          label: this.$t('Company')
        },
        {
          key: 'user_name',
          label: this.$t('User')
        },
        {
          key: 'client_url',
          label: 'Client'
        },
        {
          key: 'method',
          label: this.$t('Method')
        },
        {
          key: 'url',
          label: 'API'
        },
        {
          key: 'created_at',
          label: this.$t('Date'),
          formatter: this.$utils.formatDateTime
        }
      ],
      sys_activity_logs: [],
      detailsPreview: ''
    };
  },
  mounted() {
    const usr = authService.getLoggedUser();
    if (usr?.root !== true) {
      this.$router.push({ name: '404' });
    }

    this.getSysActivityLogs();
  },
  methods: {
    showDetails(log) {
      this.detailsModal = true;
      this.detailsPreview = JSON.stringify(log?.data, null, 4);
    },
    changePage(page) {
      this.page = page;
      this.getSysActivityLogs();
    },
    getSysActivityLogs() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/sys_activity_log', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.sys_activity_logs = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    onSearch(search = '') {
      this.search = search;
      this.getSysActivityLogs();
    },
    copyDetails() {
      navigator.clipboard
        .writeText(this.detailsPreview)
        .then(() => {
          this.$customAlert({
            msg: this.$t('Objeto copiado'),
            type: 'success'
          });
        })
        .catch((error) => {
          console.error('Failed to copy:', error);
        });
    }
  },
  computed: {
    sys_activity_logTable() {
      return this.sys_activity_logs.map((l) => {
        return {
          company_name: l.company.name,
          user_name: l.user.name,
          url: l.detail?.api_url || '',
          client_url: l.detail?.origin || '',
          method: l.detail?.method || '',
          domain: l.detail?.domain || '',
          data: l.detail,
          ...l
        };
      });
    }
  }
};
</script>

<style>
.copy-btn {
  float: right;
  padding-bottom: 5px;
  color: #afafaf;
  font-size: 1.4rem;
  cursor: pointer;
}
</style>
